import React from "react";
import ComboBox from "../formElements/ComboBox";

function ComboWithOptions(props) {
    return (
        <td>
            <ComboBox options={props.options} optionDisplay={props.optionDisplay} value={props.value}
                      onChange={(event) => props.select(event, props.ndx, props.index)} key={props.index}
                      stateResetOnChange={props.stateResetOnChange} name={props.name} reset={props.reset}/>
        </td>
    )
}

export default ComboWithOptions
